export enum Roles {
  PATIENT_REGISTRATION_ACCESS = 10,
  PATIENT_UPDATE_ACCESS = 11,
  APPOINTMENT_ACCESS = 20,
  APPOINTMENT_UPDATE_ACCESS = 21,
  APPOINTMENT_CHECKED_ACCESS = 22,
  TOKEN_ACCESS = 30,
  VITAL_ACCESS = 40,
  UPDATE_VITAL_ACCESS = 41,
  REPORTING_ACCESS = 50,
  USER_CATEGORIES_ACCESS = 60,
  UPDATE_USER_CATEGORY_ACCESS = 61,
  DELETE_USER_CATEGORY_ACCESS = 62,
  INSURANCE_COMPANY_ACCESS = 70,
  UPDATE_INSURANCE_COMPANY_ACCESS = 71,
  DELETE_INSURANCE_COMPANY_ACCESS = 72,
  INSURANCE_SERVICES_ACCESS = 80,
  UPDATE_INSURANCE_SERVICES_ACCESS = 81,
  DELETE_INSURANCE_SERVICES_ACCESS = 82,
}


const formEnums = {
  referalForm: "Patient Refferal Form",
  emergencyForm: "Emergency Form",
  deathForm: "DeathForm",
  dischargeForm: 'DischargeForm',
  ipd_patientHistory: 'History',
  ipd_BTRR: 'Blood Transfusion',
  PatientAssessmentForm: "PatientAssessmentForm",
  PostAnathesia: "PostAnathesia",
  OT_Nurse: "OT_Nurse",
  otroomanaesthesiamonitoring: "otroomanaesthesiamonitoring",
  VitalAndIOPChart: "VitalAndIOPChart",
  History:'History',
  Examination:'Examination',
  Investegation:'Investegation',
  Treatment:'Treatment',
  Pre_Anesthesia_Assessment:'Pre_Anesthesia_Assessment',
  Post_Anesthesia_Monitoring:'Post_Anesthesia_Monitoring',
  OT_Room_Anaesthesia_Monitoring:'OT_Room_Anaesthesia_Monitoring',
  Daily_Progress_Notes:'Daily_Progress_Notes',
  Call_To_Doctor:'Call_To_Doctor',
  OT:'OT',
  Pre_Surgical:'Pre_Surgical',
  Per_Operation:'Per_Operation',
  Post_Operation:'Post_Operation'
}

export enum ADMISSION_TYPE {
  MEDICAL = "Medical",
  SURGICAL = 'Surgical',
  CHEMOTHERAPY = 'Chemotherapy',
}

export enum RequestSource {
  OPD = 'OPD',
  IPD = 'IPD',
}